import { faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"

type Props = {
    errorMessage?: string
}

export const FormErrorMessage = ({ errorMessage }: Props) => {
    return (
        <React.Fragment>
            {
                <div style={{ display: "flex", alignItems: "center", marginTop: "5px", marginLeft: "10px" }}>
                    <FontAwesomeIcon icon={faTimesCircle} color="#e74c3c" />
                    <p style={{ color: "red", margin: "5px", marginLeft: "10px" }}><i>{errorMessage}</i></p>
                </div>
            }
        </React.Fragment>
    )
}